export default __webpack_public_path__ + "static/enceinte1-8c8a80d364b9b01322d761284996329e.jpg";